import { ReactElement, ReactNode } from 'react';
import { useField } from 'react-final-form';
import { RichTextEditor } from './RichTextEditor';
import { fieldSubscription, FormGroup, getVisibleFieldError, useFieldProps } from '@ff-it/form';
import { Box, Size } from '@ff-it/ui';
import type { EditorValue } from './types';

type RichTextFieldProps = {
  name: string;
  label?: ReactNode;
  id?: string;
  required?: boolean;
  size?: Size;
  help?: React.ReactNode;
  className?: string;
  placeholder?: string;
  attachments?: boolean;
  testId?: string;
};

export function RichTextField(props: RichTextFieldProps): ReactElement {
  const { name, label, className, help, testId = `${name}-field`, size = 'sm', ...rest } = useFieldProps(props);
  const { input, meta } = useField<EditorValue>(name, {
    allowNull: true,
    subscription: fieldSubscription,
  });

  const fieldProps = {
    ...input,
    valid: getVisibleFieldError(meta) ? false : undefined,
    ...rest,
  };

  return (
    <FormGroup className={className} label={label} id={rest.id} help={help} meta={meta} required={fieldProps.required}>
      <Box textSize={size}>
        <RichTextEditor {...fieldProps} testId={testId} />
      </Box>
    </FormGroup>
  );
}
